import { useCallback } from 'react'
import type { Bug } from '../data/projectTypes'
import { useLazyGetProjectBugsQuery } from '../services/projectDataApi'

export interface LoadAllProjectBugsFilters {
  projectId: string
  status?: string
  severitySort?: 'asc' | 'desc' | null
  severity?: string
  kind?: string
  environment?: string
}

// Paginate through every matching bug for a project, applying the same filters the bug list uses
// (open bugs only, via hideResolved). Shared by the Copy and Download bug-report actions so both
// gather an identical set of bugs without each maintaining its own fetch loop.
export function useLoadAllProjectBugs(): (filters: LoadAllProjectBugsFilters) => Promise<Bug[]> {
  const [loadBugs] = useLazyGetProjectBugsQuery()
  return useCallback(
    async ({ projectId, status, severitySort, severity, kind, environment }: LoadAllProjectBugsFilters) => {
      const pageSize = 100
      const allBugs: Bug[] = []
      for (let page = 1; ; page += 1) {
        const result = await loadBugs({ projectId, page, pageSize, status, hideResolved: true, severitySort: severitySort ?? undefined, severity, kind, environment }).unwrap()
        allBugs.push(...result.items)
        if (result.items.length === 0 || page * result.pageSize >= result.total) break
      }
      return allBugs
    },
    [loadBugs],
  )
}
